// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../icons/monitor-tab-icon.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.monitor-tab-icon {
    -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.serial-monitor {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.serial-monitor-messages {
    white-space: "pre";
    font-family: monospace;
}

.serial-monitor-messages pre {
    margin: 0px;
}

.serial-monitor .head {
    display: flex;
    padding: 0px 5px 5px 5px;
    height: 27px;
    background-color: var(--theia-activityBar-background);
}

.serial-monitor .head .send {
    display: flex;
    flex: 1;
}

.serial-monitor .head .send > label:before {
    content: "";
    position: absolute;
    top: -1px;
    background: var(--theia-icon-loading-warning) center center no-repeat;
    animation: theia-spin 1.25s linear infinite;
    width: 30px;
    height: 30px;
}

.serial-monitor .head .send > label {
    position: relative;
    width: 100%;
    display: flex;
    align-self: baseline;
}

.serial-monitor .head .send > input,
.serial-monitor .head .send > label > input {
    line-height: var(--theia-content-line-height);
    height: 27px;
    width: 100%;
}

.serial-monitor .head .send > label > input {
    padding-left: 30px;
    box-sizing: border-box;
}

.serial-monitor .head .send > input:focus,
.serial-monitor .head .send > label > input:focus {
    border-color: var(--theia-focusBorder);
}

.serial-monitor .head .config {
    display: flex;
}

.serial-monitor .head .config .select {
    margin-left: 3px;
}

.serial-monitor .body {
    overflow: auto;
    flex: 1;
    padding: 5px;
}

.p-TabBar-toolbar .item.arduino-monitor {
    width: 24px;
    justify-content: center;
    font-size: medium;
    box-sizing: border-box;
}

.p-TabBar-toolbar .item.arduino-monitor.toggled {
    background: var(--theia-sideBarSectionHeader-background);
    filter: contrast(80%);
}

.p-TabBar-toolbar .item .clear-all {
    background: var(--theia-icon-clear) no-repeat;
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/arduino-ide-extension/src/browser/style/monitor.css"],"names":[],"mappings":"AAAA;IACI,qDAAkD;IAClD,6CAA0C;AAC9C;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,wBAAwB;IACxB,YAAY;IACZ,qDAAqD;AACzD;;AAEA;IACI,aAAa;IACb,OAAO;AACX;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,qEAAqE;IACrE,2CAA2C;IAC3C,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,oBAAoB;AACxB;;AAEA;;IAEI,6CAA6C;IAC7C,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;;IAEI,sCAAsC;AAC1C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,wDAAwD;IACxD,qBAAqB;AACzB;;AAEA;IACI,6CAA6C;AACjD","sourcesContent":[".monitor-tab-icon {\r\n    -webkit-mask: url(\"../icons/monitor-tab-icon.svg\");\r\n    mask: url(\"../icons/monitor-tab-icon.svg\");\r\n}\r\n\r\n.serial-monitor {\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.serial-monitor-messages {\r\n    white-space: \"pre\";\r\n    font-family: monospace;\r\n}\r\n\r\n.serial-monitor-messages pre {\r\n    margin: 0px;\r\n}\r\n\r\n.serial-monitor .head {\r\n    display: flex;\r\n    padding: 0px 5px 5px 5px;\r\n    height: 27px;\r\n    background-color: var(--theia-activityBar-background);\r\n}\r\n\r\n.serial-monitor .head .send {\r\n    display: flex;\r\n    flex: 1;\r\n}\r\n\r\n.serial-monitor .head .send > label:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: -1px;\r\n    background: var(--theia-icon-loading-warning) center center no-repeat;\r\n    animation: theia-spin 1.25s linear infinite;\r\n    width: 30px;\r\n    height: 30px;\r\n}\r\n\r\n.serial-monitor .head .send > label {\r\n    position: relative;\r\n    width: 100%;\r\n    display: flex;\r\n    align-self: baseline;\r\n}\r\n\r\n.serial-monitor .head .send > input,\r\n.serial-monitor .head .send > label > input {\r\n    line-height: var(--theia-content-line-height);\r\n    height: 27px;\r\n    width: 100%;\r\n}\r\n\r\n.serial-monitor .head .send > label > input {\r\n    padding-left: 30px;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.serial-monitor .head .send > input:focus,\r\n.serial-monitor .head .send > label > input:focus {\r\n    border-color: var(--theia-focusBorder);\r\n}\r\n\r\n.serial-monitor .head .config {\r\n    display: flex;\r\n}\r\n\r\n.serial-monitor .head .config .select {\r\n    margin-left: 3px;\r\n}\r\n\r\n.serial-monitor .body {\r\n    overflow: auto;\r\n    flex: 1;\r\n    padding: 5px;\r\n}\r\n\r\n.p-TabBar-toolbar .item.arduino-monitor {\r\n    width: 24px;\r\n    justify-content: center;\r\n    font-size: medium;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.p-TabBar-toolbar .item.arduino-monitor.toggled {\r\n    background: var(--theia-sideBarSectionHeader-background);\r\n    filter: contrast(80%);\r\n}\r\n\r\n.p-TabBar-toolbar .item .clear-all {\r\n    background: var(--theia-icon-clear) no-repeat;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
